import React from 'react';
import { browserHistory, hashHistory, IndexRedirect, Route, Router } from 'react-router';
import CkLayout from '../components/ck/CkLayout';


import { BizAcctNavbarMenu, BizEvtmNavbarMenu, BizNavbarMenu, BizSupportNavbarMenu, BizSysmNavbarMenu } from '../components/ck/CkMenu'
import CkContentLayout from "../components/ck/CkContentLayout";
import { savedRequest, setLastLocation } from "../redux/actions/global";
import { isVasValidity, isValidityKey, isValidity, loginUserIsManager, findIsSMember } from "../services/global";
import EvtMenuSider from "../containers/evt/EvtMenuSider";
import { queryStringParam } from "../utils/index";

export default class CRouter extends React.Component {

    constructor(props) {
        super(props);

        browserHistory.listen((location, bbbb, ccc) => {
            // location is an object like window.location
            const tableBody = document.querySelector('.ck-data-table .ant-table-body');
            var tableScrollTop = 0;
            if (tableBody) {
                tableScrollTop = tableBody.scrollTop;
                console.log("tableScrollTop", tableScrollTop, bbbb, ccc)
            }

            console.log("CRouter", location)
            this.props.store.dispatch(setLastLocation(location, tableScrollTop))
        })
        window.addEventListener('message', function (e) {
            var data = {
                token: localStorage.getItem('token'),
                nickname: props.store.getState().loginedUser.data ? props.store.getState().loginedUser.data.nickname : ''
            }
            window.parent.postMessage(JSON.stringify(data), 'http://www.checkinmaster.com/');
        }, false);
    }

    requireAuth = (permission, component) => {
        const { store } = this.props;
        const { auth } = store.getState().httpData;
        if (!auth || !auth.data.permissions.includes(permission))
            hashHistory.replace('/403');
        return component;
    };

    requireVasValidity = (cb, svcVas, component, page = 0) => {
        let renderComp;
        if (queryStringParam('key')) {
            isValidityKey({ svcVas: svcVas, key: queryStringParam('key') }, (vaild) => {
                if (page == 1) {
                    renderComp = vaild ? component : require('../containers/interact/SigninWallGuidePage').default;
                } else if (page == 2) {
                    renderComp = vaild ? component : require('../containers/evt/stats/CheckinGuidePage').default;
                } else if (page == 3) {
                    renderComp = vaild ? component : require('../containers/evt/stats/RegisterCheckinGuidePage').default;
                } else if (page == 4) {
                    renderComp = vaild ? component : require('../containers/evt/stats/QuestionGuidePage').default;
                } else if (page == 5) {
                    renderComp = vaild ? component : require('../containers/luckydraw/LuckydrawGuidePage').default;
                } else if (page == 6) {
                    renderComp = vaild ? component : require('../containers/luckydraw/AttendeeLuckydrawGuidePage').default;
                } else if (page == 7) {
                    renderComp = vaild ? component : require('../containers/questionnaire/VotesGuidePage').default;
                } else if (page == 8) {
                    renderComp = vaild ? component : require('../containers/barrage/BarrageGuidePage').default;
                } else if (page == 11) {
                    renderComp = vaild ? component : require('../containers/evt/face-recognition/FaceCheckinGuidePage').default;
                } else {
                    renderComp = vaild ? component : require('../containers/AvailableMembershipForbidden').default;
                }

                cb(null, renderComp);
            })
        } else {
            isValidity(svcVas, (vaild) => {
                if (page == 1) {
                    renderComp = vaild ? component : require('../containers/interact/SigninWallGuidePage').default;
                } else if (page == 2) {
                    renderComp = vaild ? component : require('../containers/evt/stats/CheckinGuidePage').default;
                } else if (page == 3) {
                    renderComp = vaild ? component : require('../containers/evt/stats/RegisterCheckinGuidePage').default;
                } else if (page == 4) {
                    renderComp = vaild ? component : require('../containers/evt/stats/QuestionGuidePage').default;
                } else if (page == 5) {
                    renderComp = vaild ? component : require('../containers/luckydraw/LuckydrawGuidePage').default;
                } else if (page == 6) {
                    renderComp = vaild ? component : require('../containers/luckydraw/AttendeeLuckydrawGuidePage').default;
                } else if (page == 7) {
                    renderComp = vaild ? component : require('../containers/questionnaire/VotesGuidePage').default;
                } else if (page == 8) {
                    renderComp = vaild ? component : require('../containers/barrage/BarrageGuidePage').default;
                } else if (page == 9) {
                    renderComp = vaild ? component : require('../containers/reward/RewardGuidePage').default;
                } else if (page == 10) {
                    renderComp = vaild ? component : require('../containers/market/MarketGuidePage').default;
                } else if (page == 11) {
                    renderComp = vaild ? component : require('../containers/evt/face-recognition/FaceCheckinGuidePage').default;
                } else if (page == 12) {
                    renderComp = vaild ? component : require('../containers/guess/GuessGuidePage').default;
                } else if (page == 13) {
                    renderComp = vaild ? component : require('../containers/promote/PromoteGuidePage').default;
                } else {
                    renderComp = vaild ? component : require('../containers/AvailableMembershipForbidden').default;
                }

                cb(null, renderComp);
            })
        }

    };


    isLogin = (nextState, replaceState) => {
        const token = localStorage.getItem('token');
        if (!token) {
            this.props.store.dispatch(savedRequest(`${nextState.location.pathname}${nextState.location.search}`))
            replaceState({
                pathname: '/login',
                state: { nextPathname: nextState.location.pathname }
            })
        }

    }

    isLoggedin = (nextState, replaceState) => {
        const token = localStorage.getItem('token')
        if (token) {
            replaceState({
                pathname: '/',
                state: { nextPathname: nextState.location.pathname }
            })
        }
    }

    isManager = (nextState, replaceState) => {
        if (!loginUserIsManager()) {
            replaceState({
                pathname: '/admin/evtm',
                state: { nextPathname: nextState.location.pathname }
            })
        }
    }

    /*getComponent={(location, cb) => {
    require.ensure([], require => {
    cb(null, require('../components/Page').default)
}, 'page')
}}
*/
    shouldComponentUpdate() {
        return false;
    }

    render() {

        return <Router history={browserHistory} key={`router-root`}>
            <Route path={'/'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../components/Page').default)
                }, 'page')
            }} onEnter={this.isLogin}>
                <IndexRedirect to="admin" />

                <Route components={CkLayout}>
                    <Route path={'admin'} getComponent={(location, cb) => {
                        require.ensure([], require => {
                            cb(null, require('../containers/Admin').default)
                        }, 'admin')
                    }} onEnter={this.isManager} />
                    <Route path={"admin"}>
                        <Route path={"evtm"} components={{ main: CkContentLayout, navbarMenu: BizNavbarMenu, siderMenu: BizEvtmNavbarMenu, }}>
                            <IndexRedirect to="dashboard" />
                            <Route path={'dashboard'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/EvtmDashboard').default)
                                }, 'evtmDashboard')
                            }} />
                            <Route path={'evt'}>
                                <IndexRedirect to="pubilshed" />
                                <Route path={'unpubilshed'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/EvtsUnpublished').default)
                                    }, 'evtsUnpublished')
                                }} />
                                <Route path={'pubilshed'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/EvtsPublished').default)
                                    }, 'evtsPublished')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/EvtCreate').default)
                                    }, 'evtCreate')
                                }} />
                                {/* <Route path={':id'} components={EvtEdit}/>*/}
                                <Route path={':evtId'} components={{ moduleMenuSider: EvtMenuSider }}>
                                    <Route path={'attendee'}>
                                        <IndexRedirect to="approved" />
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeCreate').default)
                                            }, 'evtAttendeeCreate')
                                        }} />
                                        <Route path={'approved'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeApproved').default)
                                            }, 'evtAttendeeApproved')
                                        }} />
                                        <Route path={'pending'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeePending').default)
                                            }, 'evtAttendeePending')
                                        }} />
                                        <Route path={'rejected'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeRejected').default)
                                            }, 'evtAttendeeRejected')
                                        }} />
                                        <Route path={'disabled'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeDisabled').default)
                                            }, 'evtAttendeeDisabled')
                                        }} />
                                    </Route>
                                    <Route path={'invitation'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/invitation/Invitations').default)
                                        }, 'invitations')
                                    }} />
                                    <Route path={'invitation'}>
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/invitation/InvitationCreate').default)
                                            }, 'invitationCreate')
                                        }} />
                                        <Route path={':invitationId'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/invitation/InvitationUpdate').default)
                                            }, 'invitationUpdate')
                                        }} />
                                        {/*<Route path={':invitationId'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/invitation/InvitationView').default)
                                            }, 'invitationView')
                                        }}/>*/}
                                    </Route>
                                    <Route path={'ticketorder'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/order/EvtTicketOrders').default)
                                        }, 'evtTicketOrders')
                                    }} />
                                    <Route path={'share'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/share/EvtShare').default)
                                        }, 'evtShare')
                                    }} />
                                    <Route path={'microsite'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/microsite/Microsite').default)
                                            //this.requireVasValidity(cb, 'MICROSITE', require('../containers/evt/microsite/Microsite').default,10)
                                        }, 'evtMicrosite')
                                    }} />
                                    <Route path={'inset'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/inset/EvtInset').default)
                                        }, 'evtInset')
                                    }} />
                                    <Route path={'confirmation'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/confirmation/Confirmation').default)
                                        }, 'evtConfirmation')
                                    }} />
                                    <Route path={'notetemplate'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/noteTemplate/NoteTemplate').default)
                                        }, 'noteTemplate')
                                    }} />
                                    <Route path={'attendee-invoices'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/invoice/AttendeeInvoices').default)
                                        }, 'attendeeInvoices')
                                    }} />
                                    <Route path={'publicevent'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/publicEvt/EvtPublic').default)
                                        }, 'publicevent')
                                    }} />
                                    <Route path={'register-and-checkin-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            this.requireVasValidity(cb, 'EVENTSTATISTICS', require('../containers/evt/stats/RegisterAndCheckinStats').default, 3)
                                        }, 'registerAndCheckinStats')
                                    }} />
                                    <Route path={'checkin-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            this.requireVasValidity(cb, 'EVENTSTATISTICS', require('../containers/evt/stats/CheckinStats').default, 2)
                                        }, 'checkinStats')
                                    }} />
                                    <Route path={'periodicitycheckin-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            this.requireVasValidity(cb, 'FACECHECKIN', require('../containers/evt/stats/PeriodicityCheckinStats').default, 2)
                                        }, 'periodicityCheckinStats')
                                    }} />
                                    <Route path={'questionnaire-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            this.requireVasValidity(cb, 'EVENTSTATISTICS', require('../containers/evt/stats/QuestionnaireStats').default, 4)
                                        }, 'questionnaireStats')
                                    }} />
                                    <Route path={'signin-wall'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/signin-wall/SigninWallConfig').default)
                                        }, 'signinWallConfig')
                                    }} />
                                    <Route path={'signin-wall-message/:id'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/signin-wall/SigninWallMessage').default)
                                        }, 'signinWallMessage')
                                    }} />
                                    <Route path={'luckydraw'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/Luckydraw').default)
                                        }, 'luckydraw')
                                    }} />
                                    <Route path={'attendeeluckydrawlist'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeLuckydrawList').default)
                                        }, 'attendeeluckydrawList')
                                    }} />
                                    <Route path={'attendeeluckydraw/create'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeLuckydrawCreate').default)
                                        }, 'attendeeluckydrawCreate')
                                    }} />
                                    <Route path={'attendeeluckydraw/:poolId'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeLuckydraw').default)
                                        }, 'attendeeluckydraw')
                                    }} />
                                    <Route path={'promote'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/promote/Promote').default)
                                        }, 'promote')
                                    }} />
                                    <Route path={'wx-promote'}>
                                        <IndexRedirect to="alllevel" />
                                        <Route path={'firstlevel'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                this.requireVasValidity(cb, 'FACECHECKIN', require('../containers/evt/wxPromote/WxPromotes').default, 13)
                                            }, 'Wxpromote')
                                        }} />
                                        <Route path={'alllevel'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                this.requireVasValidity(cb, 'FACECHECKIN', require('../containers/evt/wxPromote/WxPromoteStatic').default, 13)
                                            }, 'WxpromoteStatic')
                                        }} />
                                        <Route path={':id'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/wxPromote/WxPromoteTwo').default)
                                            }, 'WxPromoteTwo')
                                        }} />
                                        <Route path={':id/attendees'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/wxPromote/WxPromoteAttendees').default)
                                            }, 'WxpromoteAttendees')
                                        }} />
                                        <Route path={'alllevel/attendee'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/wxPromote/WxPromoteAttendeeStatic').default)
                                            }, 'WxpromoteAttendeeStatic')
                                        }} />
                                    </Route>


                                    <Route path={'invitation-code'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/InvitationCode/InvitationCodes').default)
                                        }, 'InvitationCodes')
                                    }} />
                                    <Route path={'invitation-code/attendees'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/InvitationCode/InvitationCodeAttendees').default)
                                        }, 'InvitationCodeAttendees')
                                    }} />
                                    <Route path={'jackpot'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/Jackpot').default)
                                        }, 'jackpot')
                                    }} />
                                    <Route path={'bwlist/:poolId'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/Bwlist').default)
                                        }, 'bwlist')
                                    }} />
                                    <Route path={'attendeejackpot/:poolId'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeJackpot').default)
                                        }, 'attendeejackpot')
                                    }} />
                                    <Route path={'attendeebwlist/:poolId'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeBwlist').default)
                                        }, 'attendeeBwlist')
                                    }} />
                                    <Route path={'winner'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/Winner').default)
                                        }, 'winner')
                                    }} />
                                    <Route path={'attendeewinner/:poolId'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeWinner').default)
                                        }, 'attendeewinner')
                                    }} />
                                    <Route path={'dashboard'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/dashboard/EvtDashboard').default)
                                        }, 'evtDashboard')
                                    }} />
                                    <Route path={'allot'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/allot/EvtAllot').default)
                                        }, 'evtAllot')
                                    }} />
                                    <Route path={'allot/:id'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/allot/EvtAllotEdit').default)
                                        }, 'evtAllotEdit')
                                    }} />
                                    <Route path={'checkinlog'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/checkinlog/EvtCheckinlogs').default)
                                        }, 'evtCheckinlogs')
                                    }} />
                                    <Route path={'thermal-printing'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/thermal-printing/ThermalPrinting').default)
                                        }, 'evtThermalPrinting')
                                    }} />
                                    <Route path={'luckymoney'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckymoney/LuckyMoney').default)
                                            //this.requireVasValidity(cb, 'LUCKYMONEY', require('../containers/luckymoney/LuckyMoney').default,9)
                                        }, 'evtLuckyMoney')
                                    }} />
                                    <Route path={'winhistory/:id'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckymoney/WinHistory').default)
                                        }, 'evtWinHistory')
                                    }} />
                                    <Route path={'comments'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/Comments/Comments').default)
                                        }, 'evtComments')
                                    }} />
                                    <Route path={'comments/:id'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/Comments/CommentReply').default)
                                        }, 'evtCommentReply')
                                    }} />
                                    <Route path={'attendeecredit-status'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/stats/AttendeeCheckinStatus').default)
                                        }, 'attendeeCheckinStatus')
                                    }} />
                                    <Route path={'wjwattendee-status'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/customization/WjwAttendeeStatus').default)
                                        }, 'wjwAttendeeStatus')
                                    }} />
                                    <Route path={'barrage'}>
                                        <Route path={'list'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/barrage/BarrageConfigs').default)
                                            }, 'BarrageConfigs')
                                        }} />
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/barrage/BarrageCreate').default)
                                            }, 'BarrageCreate')
                                        }} />
                                        <Route path={':configId'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/barrage/BarrageEdit').default)
                                            }, 'BarrageEdit')
                                        }} />
                                        <Route path={':configId/barrage-message'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/barrage/BarrageMessage').default)
                                            }, 'BarrageMessage')
                                        }} />
                                    </Route>
                                    <Route path={'reward'}>
                                        <Route path={'list'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/reward/RewardList').default)
                                            }, 'rewardList')
                                        }} />
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/reward/RewardCreate').default)
                                            }, 'rewardCreate')
                                        }} />
                                        <Route path={':id'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/reward/RewardEdit').default)
                                            }, 'rewardEdit')
                                        }} />
                                        <Route path={':id/detail'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/reward/RewardDetails').default)
                                            }, 'rewardDetails')
                                        }} />
                                        <Route path={':id/target'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/reward/RewardTargets').default)
                                            }, 'rewardTargets')
                                        }} />
                                    </Route>
                                    <Route path={'market'}>
                                        <Route path={'list'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/market/MarketList').default)
                                            }, 'marketList')
                                        }} />
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/market/MarketCreate').default)
                                            }, 'marketCreate')
                                        }} />
                                        <Route path={':id'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/market/MarketEdit').default)
                                            }, 'marketEdit')
                                        }} />
                                        <Route path={':id/purchase'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/market/MarketPurchase').default)
                                            }, 'marketPurchase')
                                        }} />
                                        <Route path={':id/goods'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/market/MarketGoods').default)
                                            }, 'marketGoods')
                                        }} />
                                    </Route>
                                    <Route path={'guess'}>
                                        <Route path={'list'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/GuessList').default)
                                            }, 'guessList')
                                        }} />
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/GuessCreate').default)
                                            }, 'GuessCreate')
                                        }} />
                                        <Route path={':id'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/GuessEdit').default)
                                            }, 'guessEdit')
                                        }} />
                                        <Route path={':id/subject'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/SubjectCreateOrEdit').default)
                                            }, 'subjectCreateOrEdit')
                                        }} />
                                        <Route path={':id/goods'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/GuessJackpot').default)
                                            }, 'guessJackpot')
                                        }} />
                                        <Route path={':id/rankings'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/guess/GuessRankingList').default)
                                            }, 'guessRankingList')
                                        }} />
                                    </Route>
                                </Route>
                            </Route>
                            <Route path={'pubilshedtotal'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/EvtsPublishedTotal').default)
                                }, 'evtsPublishedTotal')
                            }} />
                            <Route path={'event-groups'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/publicEvt/EvtGroups').default)
                                }, 'evtGroups')
                            }} />
                            <Route path={'attendeecredit-status'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/stats/AttendeeCheckinStatus').default)
                                }, 'attendeeCheckinStatus')
                            }} />
                            <Route path={'publicevent'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/publicEvt/EvtPublic').default)
                                }, 'publicevent')
                            }} />
                            <Route path={'history'}>
                                <IndexRedirect to="register" />
                                <Route path={'checkin'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/checkinlog/UserCheckinLogs').default)
                                    }, 'evtCheckinlogs')
                                }} />
                                <Route path={'register'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/checkinlog/UserRegisterlogs').default)
                                    }, 'evtRegisterlogs')
                                }} />

                            </Route>
                            <Route path={'questionnaire'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/questionnaire/Questionnaires').default)
                                }, 'questionnaires')
                            }} />
                            <Route path={'questionnaire'}>
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/QuestionnairesCreate').default)
                                    }, 'questionnairesCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/QuestionnairesEdit').default)
                                    }, 'questionnairesEdit')
                                }} />
                                <Route path={':id/answerlist'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/AnswerList').default)
                                    }, 'answerList')
                                }} />
                                <Route path={':id/questionnaires-statistics'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/QuestionnairesStatistics').default)
                                    }, 'questionnairesStatistics')
                                }} />
                            </Route>
                            <Route path={'votes'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/questionnaire/Votes').default)
                                }, 'votes')
                            }} />
                            <Route path={'votes'}>
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/VotesCreate').default)
                                    }, 'votesCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/VotesEdit').default)
                                    }, 'votesEdit')
                                }} />
                                <Route path={':id/votesstatisticslist'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/questionnaire/VotesStatisticsList').default)
                                    }, 'votesStatisticsList')
                                }} />
                            </Route>


                            <Route path={'barrage'}>
                                <Route path={'list'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/barrage/BarrageConfigs').default)
                                    }, 'BarrageConfigs')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/barrage/BarrageCreate').default)
                                    }, 'BarrageCreate')
                                }} />
                                <Route path={':configId'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/barrage/BarrageEdit').default)
                                    }, 'BarrageEdit')
                                }} />
                                <Route path={':configId/barrage-message'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/barrage/BarrageMessage').default)
                                    }, 'BarrageMessage')
                                }} />
                            </Route>
                            <Route path={'reward'}>
                                <Route path={'list'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/reward/RewardList').default)
                                    }, 'rewardList')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/reward/RewardCreate').default)
                                    }, 'rewardCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/reward/RewardEdit').default)
                                    }, 'rewardEdit')
                                }} />
                                <Route path={':id/detail'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/reward/RewardDetails').default)
                                    }, 'rewardDetails')
                                }} />
                                <Route path={':id/target'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/reward/RewardTargets').default)
                                    }, 'rewardTargets')
                                }} />
                            </Route>
                            <Route path={'market'}>
                                <Route path={'list'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/market/MarketList').default)
                                    }, 'marketList')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/market/MarketCreate').default)
                                    }, 'marketCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/market/MarketEdit').default)
                                    }, 'marketEdit')
                                }} />
                                <Route path={':id/purchase'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/market/MarketPurchase').default)
                                    }, 'marketPurchase')
                                }} />
                                <Route path={':id/goods'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/market/MarketGoods').default)
                                    }, 'marketGoods')
                                }} />
                            </Route>
                            <Route path={'guess'}>
                                <Route path={'list'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/GuessList').default)
                                    }, 'guessList')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/GuessCreate').default)
                                    }, 'GuessCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/GuessEdit').default)
                                    }, 'guessEdit')
                                }} />
                                <Route path={':id/subject'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/SubjectCreateOrEdit').default)
                                    }, 'subjectCreateOrEdit')
                                }} />
                                <Route path={':id/goods'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/GuessJackpot').default)
                                    }, 'guessJackpot')
                                }} />
                                <Route path={':id/rankings'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/guess/GuessRankingList').default)
                                    }, 'guessRankingList')
                                }} />
                            </Route>


                            <Route path={'contacts'}>
                                <IndexRedirect to="allcontact" />
                                <Route path={'allcontact'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/contact/AllContact').default)
                                    }, 'allContact')
                                }} />
                                <Route path={'onlygroup/:id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/contact/OnlyGroup').default)
                                    }, 'onlyGroup')
                                }} />
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/contact/ContactCreate').default)
                                    }, 'contactCreate')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/contact/ContactEdit').default)
                                    }, 'contactEdit')
                                }} />
                            </Route>

                            <Route path={'ibeacons'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/ibeacon/Ibeacon').default)
                                }, 'ibeacon')
                            }} />
                            <Route path={'livestream'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/interact/LiveStream').default)
                                }, 'liveStream')
                            }} />
                            <Route path={'interact-lists'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/interact/InteractList').default)
                                }, 'interactList')
                            }} />
                            <Route path={'msglog'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/msglog/Msglog').default)
                                }, 'msglog')
                            }} />
                            <Route path={'wechatauth'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/usersfrom/WxAuthDashboard').default)
                                }, 'wxAuthDashboard')
                            }} />
                            <Route path={'guest-library'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/GuestLibrary/GuestLibrarys').default)
                                }, 'guestLibrarys')
                            }} />
                            <Route path={'attendeeluckydrawlist'}>
                                <IndexRedirect to=":evtId" />
                                <Route path={':evtId'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/luckydraw/AttendeeLuckydrawList').default)
                                    }, 'attendeeluckydrawlist')
                                }} />
                            </Route>
                            <Route path={':evtId/attendeeluckydraw/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/luckydraw/AttendeeLuckydrawCreate').default)
                                }, 'attendeeluckydrawCreate')
                            }} />
                            <Route path={':evtId/attendeeluckydraw/:poolId'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/luckydraw/AttendeeLuckydraw').default)
                                }, 'attendeeluckydraw')
                            }} />
                            <Route path={':evtId/attendeejackpot/:poolId'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/luckydraw/AttendeeJackpot').default)
                                }, 'attendeejackpot')
                            }} />
                            <Route path={':evtId/attendeebwlist/:poolId'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/luckydraw/AttendeeBwlist').default)
                                }, 'attendeeBwlist')
                            }} />
                            <Route path={':evtId/attendeewinner/:poolId'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/luckydraw/AttendeeWinner').default)
                                }, 'attendeewinner')
                            }} />
                            <Route path={'attendeeluckydrawgp'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/easy-touch/AttendeeLuckydrawGuidepage').default)
                                }, 'AttendeeLuckydrawGuidepage')
                            }} />
                            <Route path={'organizerluckydrawgp'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/easy-touch/OrganizerLuckydrawGuidepage').default)
                                }, 'OrganizerLuckydrawGuidepage')
                            }} />
                            <Route path={'signwallgp'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/easy-touch/SignWallGuidepage').default)
                                }, 'SignWallGuidepage')
                            }} />
                            <Route path={'writecheckin'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/easy-touch/WriteCheckinGuidepage').default)
                                }, 'writeCheckinGuidepage')
                            }} />
                            <Route path={'redpacketsgp'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/easy-touch/RedPacketsGuidepage').default)
                                }, 'redPacketsGuidepage')
                            }} />





                        </Route>
                        <Route path={"acct"} components={{ main: CkContentLayout, navbarMenu: BizNavbarMenu, siderMenu: BizAcctNavbarMenu }}>
                            <IndexRedirect to="wallet" />
                            <Route path={'withdraw'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/withdraw/Withdraws').default)
                                }, 'wallet')
                            }} />
                            <Route path={'wallet'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/wallet/Wallet').default)
                                }, 'wallet')
                            }} />
                            <Route path={'invoice'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invoice/Invoices').default)
                                }, 'invoices')
                            }} />
                            <Route path={'invoice/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invoice/InvoiceCreate').default)
                                }, 'invoiceCreate')
                            }} />
                            <Route path={'cm-order'}>
                                <IndexRedirect to="vasorder" />
                                <Route path={'ticketorder'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/TicketOrders').default)
                                    }, 'ticketOrders')
                                }} />
                                <Route path={'vasorder'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/VasOrders').default)
                                    }, 'vasOrders')
                                }} />
                                <Route path={'orders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/Orders').default)
                                    }, 'evtmOrders')
                                }} />
                                <Route path={'rewardorders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/RewardOrders').default)
                                    }, 'rewardOrders')
                                }} />
                                <Route path={'marketorders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/MarketOrders').default)
                                    }, 'marketOrders')
                                }} />
                            </Route>
                        </Route>
                        {/*<Route path={"mshp"} components={{main: CkContentLayout, navbarMenu: BizNavbarMenu, siderMenu: BizAcctNavbarMenu}}>
                                <IndexRedirect to="membership"/>
                                <Route path={'membership'} components={Membership}/>

                            </Route>*/}
                        <Route path={"mall"} components={{ main: CkContentLayout, navbarMenu: BizNavbarMenu, siderMenu: null }}>
                            <IndexRedirect to="products" />
                            <Route path={'products'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/mall/MallProducts').default)
                                }, 'mallProducts')
                            }} />
                        </Route>

                        <Route path={"shopping"} components={{ main: CkContentLayout, navbarMenu: BizNavbarMenu, siderMenu: null }}>
                            <Route path={'buy'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/shopping/ConfirmBuyOrderInfo').default)
                                }, 'confirmBuyOrderInfo')
                            }} />
                            <Route path={'cashier'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/shopping/Cashier').default)
                                }, 'cashier')
                            }} />
                            <Route path={'pay-result'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/shopping/PayResult').default)
                                }, 'payResult')
                            }} />
                        </Route>

                        <Route path={"sysm"} components={{ main: CkContentLayout, siderMenu: BizSysmNavbarMenu }} title="后台管理" siderTheme="light" onEnter={this.isManager}>
                            <IndexRedirect to="dashboard" />
                            <Route path={'dashboard'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/SysmDashboard').default)
                                }, 'sysmDashboard')
                            }} />
                            <Route path={'user'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/user/Users').default)
                                }, 'users')
                            }} />
                            <Route path={'user/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/user/UserCreate').default)
                                }, 'userCreate')
                            }} />
                            <Route path={'user/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/user/UserEdit').default)
                                }, 'userEdit')
                            }} />
                            <Route path={'role'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/role/Roles').default)
                                }, 'roles')
                            }} />
                            <Route path={'role/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/role/RoleCreate').default)
                                }, 'roleCreate')
                            }} />
                            <Route path={'role/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/role/RoleEdit').default)
                                }, 'roleEdit')
                            }} />
                            <Route path={'android-client'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/AndroidClient').default)
                                }, 'androidClient')
                            }} />
                            <Route path={'android-client/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/AndroidClientCreate').default)
                                }, 'androidClientCreate')
                            }} />
                            <Route path={'android-client/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/AndroidClientEdit').default)
                                }, 'androidClientEdit')
                            }} />
                            <Route path={'ios-client'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/iOSClient').default)
                                }, 'iOSClient')
                            }} />
                            <Route path={'ios-client/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/iOSClientCreate').default)
                                }, 'iOSClientCreate')
                            }} />
                            <Route path={'ios-client/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/iOSClientEdit').default)
                                }, 'iOSClientEdit')
                            }} />
                            <Route path={'pc-client'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/PCClient').default)
                                }, 'pCClient')
                            }} />
                            <Route path={'pc-client/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/PCClientCreate').default)
                                }, 'pCClientCreate')
                            }} />
                            <Route path={'pc-client/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/PCClientEdit').default)
                                }, 'pCClientEdit')
                            }} />
                            <Route path={'invitation-bgm'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-bgm/InvitationBgms').default)
                                }, 'invitationBgms')
                            }} />
                            <Route path={'invitation-bgm/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-bgm/InvitationBgmCreate').default)
                                }, 'invitationBgmCreate')
                            }} />
                            <Route path={'invitation-bgm/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-bgm/InvitationBgmEdit').default)
                                }, 'invitationBgmEdit')
                            }} />
                            <Route path={'invitation-tpl'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-tpl/InvitationTpls').default)
                                }, 'invitationTpls')
                            }} />
                            <Route path={'invitation-tpl/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-tpl/InvitationTplCreate').default)
                                }, 'invitationTplCreate')
                            }} />
                            <Route path={'invitation-tpl/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/invitation-tpl/InvitationTplEdit').default)
                                }, 'invitationTplEdit')
                            }} />
                            <Route path={'sms-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/sms-config/SmsConfig').default)
                                }, 'smsConfig')
                            }} />
                            <Route path={'sms-config/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/sms-config/SmsConfigCreate').default)
                                }, 'smsConfigCreate')
                            }} />
                            <Route path={'sms-config/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/sms-config/SmsConfigEdit').default)
                                }, 'smsConfigEdit')
                            }} />
                            <Route path={'customer-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/customer-config/CustomerConfig').default)
                                }, 'customerConfig')
                            }} />
                            <Route path={'customer-config/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/customer-config/CustomerConfigCreate').default)
                                }, 'customerConfigCreate')
                            }} />
                            <Route path={'customer-config/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/customer-config/CustomerConfigEdit').default)
                                }, 'customerConfigEdit')
                            }} />
                            <Route path={'ibeacon-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/ibeacon-config/IbeaconConfig').default)
                                }, 'ibeaconConfig')
                            }} />
                            <Route path={'ibeacon-config/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/ibeacon-config/IbeaconConfigCreate').default)
                                }, 'ibeaconConfigCreate')
                            }} />
                            <Route path={'appintro-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/client/AppIntroConfig').default)
                                }, 'appIntroConfig')
                            }} />
                            <Route path={'pay-config'}>
                                <IndexRedirect to="merchantList" />
                                <Route path={'merchantList'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/payConfig/merchantList').default)
                                    }, 'merchantList')
                                }} />
                            </Route>


                            <Route path={'dynamic'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/inform/Dynamic').default)
                                }, 'sysmDynamic')
                            }} />
                            <Route path={'dynamic'}>
                                <Route path={'create'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/inform/CreateDynamic').default)
                                    }, 'sysmCreateDynamic')
                                }} />
                                <Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/inform/EditDynamic').default)
                                    }, 'sysmEditDynamic')
                                }} />
                            </Route>
                        </Route>
                        <Route path={"support"} components={{ main: CkContentLayout, siderMenu: BizSupportNavbarMenu }} title="运营管理" siderTheme="light" onEnter={this.isManager}>
                            <IndexRedirect to="dashboard" />
                            <Route path={'msglog'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/msglog/Msglog').default)
                                }, 'msglog')
                            }} />
                            <Route path={'indep-roll'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/business/IndepRoll').default)
                                }, 'indepRoll')
                            }} />
                            <Route path={'reward-list'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/reward/AdminRewardList').default)
                                }, 'adminRewardList')
                            }} />
                            <Route path={'market-list'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/market/AdminMarketList').default)
                                }, 'adminMarketList')
                            }} />
                            <Route path={'guess-list'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/guess/AdminGuessList').default)
                                }, 'adminGuessList')
                            }} />
                            <Route path={'questionnaire'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/business/Questionnaire').default)
                                }, 'questionnaire')
                            }} />
                            <Route path={'votes'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/business/Votes').default)
                                }, 'votes')
                            }} />
                            <Route path={'evt-operation'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/EventOperationCount').default)
                                }, 'evtOperation')
                            }} />
                            <Route path={'except-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/business/ExceptConfig').default)
                                }, 'exceptConfig')
                            }} />
                            <Route path={'experience-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/experience-config/Experiences').default)
                                }, 'supportExperiences')
                            }} />
                            <Route path={'dashboard'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/SupportDashboard').default)
                                }, 'supportDashboard')
                            }} />

                            <Route path={'evt'}>
                                <IndexRedirect to="pubilshed" />
                                <Route path={'unpubilshed'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/AdminEvtsUnpublished').default)
                                    }, 'adminEvtsUnpublished')
                                }} />
                                <Route path={'pubilshed'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/AdminEvtsPublished').default)
                                    }, 'adminEvtsPublished')
                                }} />

                                {/*<Route path={':id'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/EvtEdit').default)
                                    }, 'supportEvtEdit')
                                }}/>*/}
                                <Route path={':evtId'} components={{ moduleMenuSider: EvtMenuSider }}>
                                    <Route path={'attendee'}>
                                        <IndexRedirect to="approved" />
                                        <Route path={'approved'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeApproved').default)
                                            }, 'supportEvtAttendeeApproved')
                                        }} />
                                        <Route path={'pending'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeePending').default)
                                            }, 'supportEvtAttendeePending')
                                        }} />
                                        <Route path={'rejected'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeRejected').default)
                                            }, 'supportEvtAttendeeRejected')
                                        }} />
                                        <Route path={'disabled'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/evt/attendee/EvtAttendeeDisabled').default)
                                            }, 'supportEvtAttendeeDisabled')
                                        }} />
                                    </Route>
                                    <Route path={'invitation'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/invitation/Invitations').default)
                                        }, 'supportInvitations')
                                    }} />
                                    <Route path={'invitation'}>
                                        <Route path={'create'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/invitation/InvitationCreate').default)
                                            }, 'supportInvitationCreate')
                                        }} />
                                        <Route path={':invitationId'} getComponent={(location, cb) => {
                                            require.ensure([], require => {
                                                cb(null, require('../containers/invitation/InvitationView').default)
                                            }, 'supportInvitationView')
                                        }} />
                                    </Route>
                                    <Route path={'ticketorder'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/order/AdminEvtTicketOrders').default)
                                        }, 'adminEvtTicketOrders')
                                    }} />
                                    <Route path={'register-and-checkin-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/stats/RegisterAndCheckinStats').default)
                                        }, 'supportRegisterAndCheckinStats')
                                    }} />
                                    <Route path={'checkin-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/stats/CheckinStats').default)
                                        }, 'supportCheckinStats')
                                    }} />
                                    <Route path={'questionnaire-stats'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/stats/QuestionnaireStats').default)
                                        }, 'supportQuestionnaireStats')
                                    }} />

                                    <Route path={'signin-wall'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/signin-wall/SigninWallConfig').default)
                                        }, 'supportSigninWallConfig')
                                    }} />
                                    <Route path={'luckydraw'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/Luckydraw').default)
                                        }, 'supportLuckydraw')
                                    }} />
                                    <Route path={'attendeeluckydrawlist'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckydraw/AttendeeLuckydrawList').default)
                                        }, 'attendeeluckydrawlist')
                                    }} />
                                    <Route path={'dashboard'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/dashboard/EvtDashboard').default)
                                        }, 'supportEvtDashboard')
                                    }} />
                                    <Route path={'checkinlog'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/checkinlog/EvtCheckinlogs').default)
                                        }, 'supportEvtCheckinlogs')
                                    }} />
                                    <Route path={'allot'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/allot/EvtAllot').default)
                                        }, 'supportEvtAllot')
                                    }} />
                                    <Route path={'share'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/share/EvtShare').default)
                                        }, 'supportEvtShare')
                                    }} />
                                    <Route path={'inset'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/inset/EvtInset').default)
                                        }, 'supportEvtInset')
                                    }} />
                                    <Route path={'confirmation'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/confirmation/Confirmation').default)
                                        }, 'supportConfirmation')
                                    }} />
                                    <Route path={'promote'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/promote/Promote').default)
                                        }, 'supportEvtpromote')
                                    }} />
                                    <Route path={'thermal-printing'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/thermal-printing/ThermalPrinting').default)
                                        }, 'supportThermalPrinting')
                                    }} />
                                    <Route path={'luckymoney'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckymoney/LuckyMoney').default)
                                            // this.requireVasValidity(cb, 'LUCKYMONEY', require('../containers/luckymoney/LuckyMoney').default,9)
                                        }, 'supportLuckyMoney')
                                    }} />
                                    <Route path={'winhistory/:id'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/luckymoney/WinHistory').default)
                                        }, 'supportWinHistory')
                                    }} />
                                    <Route path={'microsite'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/microsite/Microsite').default)
                                        }, 'supportMicrosite')
                                    }} />
                                    <Route path={'wx-promote'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/wxPromote/WxPromotes').default)
                                        }, 'supportWxPromotes')
                                    }} />
                                    <Route path={'invitation-code'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/InvitationCode/InvitationCodes').default)
                                        }, 'supporInvitationCodes')
                                    }} />
                                    <Route path={'comments'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/Comments/Comments').default)
                                        }, 'supComments')
                                    }} />
                                    <Route path={'attendeecredit-status'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/stats/AttendeeCheckinStatus').default)
                                        }, 'supportAttendeeCheckinStatus')
                                    }} />
                                    <Route path={'wjwattendee-status'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/customization/WjwAttendeeStatus').default)
                                        }, 'supportwjwAttendeeStatus')
                                    }} />
                                    <Route path={'attendee-invoices'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/invoice/AttendeeInvoices').default)
                                        }, 'supportattendeeInvoices')
                                    }} />
                                    <Route path={'notetemplate'} getComponent={(location, cb) => {
                                        require.ensure([], require => {
                                            cb(null, require('../containers/evt/noteTemplate/NoteTemplate').default)
                                        }, 'supportnoteTemplate')
                                    }} />
                                </Route>
                            </Route>
                            <Route path={'online-user'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/online/OnlineUsers').default)
                                }, 'onlineUsers')
                            }} />
                            <Route path={'users-statistic'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/statistic/UsersStatistic').default)
                                }, 'usersStatistic')
                            }} />
                            <Route path={'events-statistic'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/statistic/EventsStatistic').default)
                                }, 'eventsStatistic')
                            }} />
                            <Route path={'withdraw-stats'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/withdrawStats/WithdrawStats').default)
                                }, 'withdrawStats')
                            }} />
                            <Route path={'income-stats'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/incomeStats/IncomeStats').default)
                                }, 'IncomeStats')
                            }} />
                            <Route path={'user-consume-stats'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/userConsumeStats/UserConsumeStats').default)
                                }, 'UserConsumeStats')
                            }} />
                            <Route path={'invoice-verify'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/verify/InvoiceVerify').default)
                                }, 'invoiceVerify')
                            }} />
                            <Route path={'bankcard-verify'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/verify/BankcardVerify').default)
                                }, 'bankcardVerify')
                            }} />
                            <Route path={'withdraw-verify'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/verify/WithdrawVerify').default)
                                }, 'withdrawVerify')
                            }} />
                            <Route path={'withdraw'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/withdraw/Withdraws').default)
                                }, 'wallets')
                            }} />
                            <Route path={'refund-verify'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/verify/RefundVerify').default)
                                }, 'refundVerify')
                            }} />
                            <Route path={'smssign-verify'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/verify/SmssignVerify').default)
                                }, 'smssignVerify')
                            }} />
                            <Route path={'cm-order'}>
                                <IndexRedirect to="vasorder" />
                                <Route path={'ticketorder'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/AdminTicketOrders').default)
                                    }, 'adminTicketOrders')
                                }} />
                                <Route path={'vasorder'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/AdminVasOrders').default)
                                    }, 'adminVasOrders')
                                }} />
                                <Route path={'orders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/AdminOrders').default)
                                    }, 'adminOrders')
                                }} />
                                <Route path={'rewardorders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/AdminOrders').default)
                                    }, 'adminRewardOrders')
                                }} />
                                <Route path={'marketorders'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/cm-order/AdminMarketOrders').default)
                                    }, 'adminMarketOrders')
                                }} />
                            </Route>

                            <Route path={'offer'}>
                                <IndexRedirect to="informs" />
                                <Route path={'feedback'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/feedback/Feedbacks').default)
                                    }, 'feedbacks')
                                }} />
                                <Route path={'informs'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/feedback/Informs').default)
                                    }, 'informs')
                                }} />
                            </Route>
                            <Route path={'history'}>
                                <IndexRedirect to="register" />
                                <Route path={'checkin'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/checkinlog/Checkinlogs').default)
                                    }, 'adminCheckinlogs')
                                }} />
                                <Route path={'register'} getComponent={(location, cb) => {
                                    require.ensure([], require => {
                                        cb(null, require('../containers/evt/checkinlog/Registerlogs').default)
                                    }, 'adminRegisterlogs')
                                }} />
                            </Route>
                            <Route path={'vas-topup'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/vas/VasTopup').default)
                                }, 'supportVasTopup')
                            }} />
                            <Route path={'vas-svc'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/vas/VasSvc').default)
                                }, 'supportVasSvc')
                            }} />
                            <Route path={'vas-product'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/vas/VasProduct').default)
                                }, 'supportVasProduct')
                            }} />
                            <Route path={'vas-membership'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/vas/VasMembership').default)
                                }, 'supportVasMembership')
                            }} />
                            <Route path={'qcoin-transfer'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/qcoin/QcoinTransfer').default)
                                }, 'qcoinTransfer')
                            }} />
                            <Route path={'news-casus'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/website/NewsCasus').default)
                                }, 'suportNewsCasus')
                            }} />
                            <Route path={'article/create'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/website/CreateArticle').default)
                                }, 'suportCreateArticle')
                            }} />
                            <Route path={'article/:id'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/website/EditArticle').default)
                                }, 'suportEditArticle')
                            }} />
                            <Route path={'home-statistics'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/website/HomeStatistics').default)
                                }, 'suportHomeStatistics')
                            }} />
                            <Route path={'livestream-config'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/interact/LiveStreamConfig').default)
                                }, 'liveStreamConfig')
                            }} />

                        </Route>
                    </Route>
                </Route>
            </Route>
            <Route getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../components/LoginPage').default)
                }, 'loginPage')
            }}>
                <Route path={'login'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/login/Login').default)
                    }, 'login')
                }} onEnter={this.isLoggedin} />
                <Route path={'forget-passwd'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/login/ForgetPasswd').default)
                    }, 'forgetPasswd')
                }} />
                <Route path={'register'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/login/UserRegister').default)
                    }, 'userRegister')
                }} />
                <Route path={'subaccount-login'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/login/SubAccountLogin').default)
                    }, 'subAccountLogin')
                }} />

            </Route>
            <Route path={'subaccount-checkinpoints'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/subaccount/SubAccountCheckinpoints').default)
                }, 'subAccountCheckinpoints')
            }} />
            <Route getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../components/Page').default)
                }, 'page')
            }}>
                <Route path={'/admin/evtm/votes/:id/votes-statistics/:titleId'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'ONSITEVOTE', require('../containers/questionnaire/VotesStats').default, 7)
                    }, 'votesStats')
                }} />
                <Route path={'/admin/evtm/barrage/:configId/screen'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'BULLETSCREEN', require('../containers/barrage/Barrage').default, 8)
                    }, 'BarrageScreen')
                }} />
                <Route path={'/admin/evtm/reward/:id/screen'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'REWARD', require('../containers/reward/RewardScreen').default, 9)
                    }, 'rewardScreen')
                }} />
                <Route path={'/admin/evtm/market/:id/screen'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'REWARD', require('../containers/market/MarketScreen').default, 10)
                    }, 'marketScreen')
                }} />
                <Route path={'/admin/evtm/guess/:id/screen'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'REWARD', require('../containers/guess/GuessScreen').default, 12)
                    }, 'guessScreen')
                }} />
                <Route path={'evt/:evtId/checkpoint/:checkinpointId/dynamic-checkin-qrcode'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'DYNAMICQRCODE', require('../containers/evt/DynamicCheckinQrcodeView').default)
                    }, 'dynamicCheckinQrcodeView')
                }} />
                <Route path={'/admin/evtm/evt/:evtId/interact'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/interact/Interact').default)
                    }, 'interact')
                }} />
                <Route path={'/admin/evtm/evt/:evtId/begandraw'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'LUCKYDRAWBYORGNAIZER', require('../containers/luckydraw/BeganDraw').default, 5)
                    }, 'begandraw')
                }} />
                <Route path={'/admin/evtm/evt/:evtId/begandraw3d'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'LUCKYDRAWBYORGNAIZER', require('../containers/luckydraw/BeganDraw3d').default, 5)
                    }, 'begandraw3d')
                }} />
                <Route path={'/admin/evtm/evt/:evtId/attendeebegandraw/:poolId'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'LUCKYDRAWBYATTENDEE', require('../containers/luckydraw/AttendeeBeganDraw').default, 6)
                    }, 'attendeebegandraw')
                }} />
                <Route path={'/admin/evtm/evt/:evtId/luckymoneyscreen/:id'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/luckymoney/LuckMoneyScreen').default)
                    }, 'evtLuckMoneyScreen')
                }} />
                <Route path={'/evt/:evtId/checkpoint/:checkinpointId/organizer-scan-checkin'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/OrganizerScanCheckin').default)
                    }, 'organizerScanCheckin')
                }} />
                <Route path={'/evt/:evtId/checkpoint/:checkinpointId/attendee-scan-checkin'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/AttendeeScanCheckin').default)
                    }, 'attendeeScanCheckin')
                }} />
                <Route path={'/evt/:evtId/checkpoint/:checkinpointId/face-scan-checkin'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        this.requireVasValidity(cb, 'FACECHECKIN', require('../containers/evt/face-recognition/FaceRecognition').default, 11)
                    }, 'faceRecognition')
                }} />
                <Route path={'/evt/:evtId/checkpoint/:checkinpointId/face-scan-experience'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/face-recognition/FaceCheckinExperView').default)
                    }, 'faceCheckinExperView')
                }} />
                <Route path={'/evt/:evtId/promoteattendeee'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        findIsSMember({ eventId: location.params.evtId }).then(res => {
                            if (res.code == 200) {
                                cb(null, require('../containers/promote/PromoteAttendee').default)
                            } else {
                                cb(null, require('../containers/promote/PromoteGuidePage').default)
                            }
                        })
                    }, 'promoteAttendee')
                }} />
                <Route path={'sub'}>
                    <Route path={'evt'}>
                        <Route path={':evtId'} >
                            <Route path={'checkinlog'} getComponent={(location, cb) => {
                                require.ensure([], require => {
                                    cb(null, require('../containers/evt/checkinlog/EvtCheckinlogs').default)
                                }, 'evtCheckinlogs')
                            }} />
                        </Route>
                    </Route>
                </Route>
                <Route path={'/sub/evtm/evt/:evtId/checkin-stats'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/stats/CheckinStats').default)
                    }, 'checkinStats')
                }} />
                <Route path={'/sub/evtm/evt/:evtId/attendees'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/subaccount/EvtAttendees').default)
                    }, 'evtAttendees')
                }} />
                <Route path={'/sub/evtm/evt/:evtId/attendees/create'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/attendee/EvtAttendeeCreate').default)
                    }, 'evtAttendeeCreate')
                }} />
                <Route path={'/sub/evtm/evt/:evtId/checkpoint/:checkinpointId/dynamic-checkin-qrcode'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/evt/DynamicCheckinQrcodeView').default)
                    }, 'dynamicCheckinQrcodeView')
                }} />

            </Route>
            <Route path={'admin/all/products'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/mall/MallProducts').default)
                }, 'mallProducts')
            }} />
            <Route path={'3d/photo'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/luckydraw/Photo3D').default)
                }, 'Photo3D')
            }} />
            <Route path={'share/experienceview'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/experience-config/ExperienceView').default)
                }, 'experienceView')
            }} />
            <Route path={'share/questionnaire/answercollect/:id'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/questionnaire/AnswerCollect').default)
                }, 'answerCollect')
            }} />
            <Route path={'share/votes/votesanswercollect/:id'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/questionnaire/VotesAnswerCollect').default)
                }, 'votesAnswerCollect')
            }} />
            <Route path={'share/event/:id'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/event/Event').default)
                }, 'PcEvent')
            }} />
            <Route path={'print/printview/:attendeeId'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/evt/thermal-printing/PrintView').default)
                }, 'evtPrintView')
            }} />
            <Route path={'403'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/Forbidden').default)
                }, 'forbidden')
            }} />
            <Route path={'oauth-login'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/OAuthLogin').default)
                }, 'oAuthLogin')
            }} />
            <Route path={'authcodereport'} getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/AuthCodeReport').default)
                }, 'authCodeReport')
            }} />
            {/*<Route path={'test'} getComponent={(location, cb) => {*/}
            {/*require.ensure([], require => {*/}
            {/*cb(null, require('../containers/evt/face-recognition/FaceCheckinGuidePage').default)*/}
            {/*}, 'FaceRecognition')*/}
            {/*}}/>*/}


            <Route path="*" getComponent={(location, cb) => {
                require.ensure([], require => {
                    cb(null, require('../containers/NotFound').default)
                }, 'notFound')
            }} />
        </Router>


    }
}


// WEBPACK FOOTER //
// ./src/routes/index.js